export default __webpack_public_path__ + "static/media/34.5e4e7960.jpg";